/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboSizeSchema } from "./comboSizeSchema.ts";
import { localizationListSchema } from "./localizationListSchema.ts";
import { localizationStrSchema } from "./localizationStrSchema.ts";
import { modifierSchema } from "./modifierSchema.ts";
import { portionNutritionSchema } from "./portionNutritionSchema.ts";
import { productGroupModifierSchema } from "./productGroupModifierSchema.ts";

export const comboProductSchema = z
	.object({
		id: z.uuid(),
		external_id: z.uuid().nullish(),
		is_force_hidden_with_allowed_creation: z
			.boolean()
			.optional()
			.describe("Флаг, указывающий фронту на необходимость скрытия позиция. Допускает создание заказа с данным блюдом."),
		price: z.number().nullable(),
		min_price: z.number().nullable(),
		base_price: z.number().nullable().describe("Цена блюда без размеров до скидки по акции, null — акции нет."),
		base_min_price: z.number().nullable().describe("Цена до скидки по акции того же варианта, что дал min_price, null — у него нет акции."),
		discount_percent: z
			.int()
			.nullable()
			.describe("Процент скидки по акции для плашки у варианта с минимальной ценой, без учёта модификаторов; null — у него нет акции."),
		sizes: z.array(comboSizeSchema),
		modifiers: z.array(modifierSchema),
		group_modifiers: z.array(productGroupModifierSchema),
		tags: z.array(z.string()),
		badges: z.array(z.string()),
		name: z.string(),
		description: z.string().optional(),
		expected_cooking_time: z.int().min(-2147483648).max(2147483647).optional(),
		fat_amount: z.number().nullish(),
		proteins_amount: z.number().nullish(),
		carbohydrates_amount: z.number().nullish(),
		energy_amount: z.number().nullish(),
		weight: z.number().nullish(),
		portion_nutrition: portionNutritionSchema.nullable().describe("Вес и КБЖУ порции"),
		allergens: z.array(z.string()),
		barcodes: z.array(z.string()),
		groups: z.array(z.uuid()),
		adult: z.boolean(),
		upsell_set: z.string(),
		show_recommendations: z.boolean(),
		recommendation_ids: z.array(z.uuid()),
		is_fake: z.boolean().optional(),
		is_od_united_product: z.boolean(),
		has_combo: z.boolean(),
		category: z.uuid().nullish(),
		is_marked: z.boolean(),
		image_link: z.string().nullable(),
		video_link: z.string().nullable(),
		loc_name: localizationStrSchema.describe("Util serializer for representation in swagger"),
		loc_description: localizationStrSchema.describe("Util serializer for representation in swagger"),
		loc_tags: localizationListSchema.describe("Util serializer for representation in swagger"),
		loc_allergens: localizationListSchema.describe("Util serializer for representation in swagger"),
		likes_count: z.int(),
		original_price: z.number().nullable(),
		price_modification: z.number().nullable(),
	})
	.describe("Миксин для округления полей КБЖУ до целых чисел при сериализации.\nВес и КБЖУ вне допустимых пределов заменяет на null.");
